/* eslint-disable camelcase */
export enum NotificationRequestTypes {
  SHOW_REQUEST = '@notification/SHOW_REQUEST',
  SHOW_SUCCESS = '@notification/SHOW_SUCCESS',
  SHOW_FAILURE = '@notification/SHOW_FAILURE',
  UPDATE_BIDDINGS_REQUEST = '@notification/UPDATE_BIDDINGS_REQUEST',
  UPDATE_BIDDINGS_SUCCESS = '@notification/UPDATE_BIDDINGS_SUCCESS',
  UPDATE_BIDDINGS_FAILURE = '@notification/UPDATE_BIDDINGS_FAILURE',
  ADD_SINGLE_NOTIFICATION = '@notification/ADD_SINGLE_NOTIFICATION',
  READ_NOTIFICATION_REQUEST = '@notification/READ_NOTIFICATION_REQUEST',
  READ_NOTIFICATION_SUCCESS = '@notification/READ_NOTIFICATION_SUCCESS',
  READ_NOTIFICATION_FAILURE = '@notification/READ_NOTIFICATION_FAILURE',
  MARK_ALL_AS_READ = '@notification/MARK_ALL_AS_READ',
}

export interface UpdatedBiddingSpecificTypes {
  bidding_id: number;
  notification_reason_id: number;
  bidding: {
    edital: string;
    modality: {
      nome: string;
    };
    public_body: {
      nome: string;
    };
  };
}

export interface CampaignSpecificTypes {
  id: number;
  title: string;
  url: string;
}

export interface DocumentsSpecificTypes {
  id: number;
  document_name: string;
}

export interface ManagementBiddingSpecificTypes {
  id: number;
  task_id: number;
  summary: string;
  task: {
    bidding_id: number;
  };
}

export interface NotificationTypes {
  actable_id: number;
  actable_type:
    | 'Notification::UpdatedBidding'
    | 'Notification::Campaign'
    | 'Notification::ManagementBidding'
    | 'Notification::Documents';
  created_at: string;
  id: number;
  read: boolean;
  user_id: number;
  specific:
    | UpdatedBiddingSpecificTypes
    | CampaignSpecificTypes
    | DocumentsSpecificTypes
    | ManagementBiddingSpecificTypes;
}
export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface NewNotificationState {
  readonly notifications: Array<NotificationTypes>;
  readonly unreadCount: number;
  readonly request: RequestState;
}
